<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="`${username} 的登录记录`"
    width="1000px"
    @close="handleClose"
  >
    <!-- 筛选条件 -->
    <div class="filter-section">
      <el-form :inline="true" :model="filterForm" size="small">
        <el-form-item label="登录状态">
          <el-select 
            v-model="filterForm.status" 
            placeholder="请选择"
            clearable
            style="width: 120px"
            @change="handleFilter"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="成功" :value="1"></el-option>
            <el-option label="失败" :value="0"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="filterForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 300px"
            @change="handleFilter"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="small" @click="handleFilter">查询</el-button>
          <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <el-table 
      v-loading="loading"
      :data="logs" 
      style="width: 100%"
      stripe
      max-height="500"
    >
      <el-table-column type="index" label="序号" width="60" />
      
      <el-table-column prop="loginIp" label="IP地址" width="140" />
      
      <el-table-column prop="loginLocation" label="登录地点" width="100" />
      
      <el-table-column prop="browser" label="浏览器" width="100" />
      
      <el-table-column prop="os" label="操作系统" width="120" />
      
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
            {{ scope.row.status === 1 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="loginTime" label="登录时间" min-width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.loginTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pagination.total"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserLoginLogsDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      userId: null,
      username: '',
      logs: [],
      filterForm: {
        status: '',
        dateRange: []
      },
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    // 打开弹窗
    open(userId, username) {
      console.log('打开登录记录弹窗 - userId:', userId, 'username:', username)
      this.userId = userId
      this.username = username
      this.dialogVisible = true
      this.resetFilter()
      this.loadLogs()
    },
    
    // 加载日志列表
    async loadLogs() {
      if (!this.userId) {
        console.log('userId为空，无法加载日志')
        return
      }
      
      this.loading = true
      try {
        const params = {
          userId: this.userId,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        
        // 添加筛选参数
        if (this.filterForm.status !== '') {
          params.status = this.filterForm.status
        }
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          params.startDate = this.filterForm.dateRange[0]
          params.endDate = this.filterForm.dateRange[1]
        }
        
        console.log('请求登录日志 - URL:', '/login-logs/user', 'params:', params)
        
        const response = await this.$post('/login-logs/user', params)
        
        console.log('登录日志响应:', response.data)
        
        if (response.data && response.data.code === 200) {
          const data = response.data.data
          
          // 兼容两种返回格式：{list: [], total: 0} 或 直接是数组
          if (Array.isArray(data)) {
            // 旧格式：直接返回数组
            this.logs = data
            this.pagination.total = data.length
            console.log('使用数组格式 - 加载到的日志数量:', this.logs.length)
          } else if (data && data.list) {
            // 新格式：返回对象包含list和total
            this.logs = data.list || []
            this.pagination.total = data.total || 0
            console.log('使用对象格式 - 加载到的日志数量:', this.logs.length, '总数:', this.pagination.total)
          } else {
            this.logs = []
            this.pagination.total = 0
            console.log('未知格式，清空数据')
          }
        } else {
          this.$message.error(response.data?.msg || '加载失败')
        }
      } catch (error) {
        console.error('加载用户登录记录失败:', error)
        this.$message.error('加载失败')
      } finally {
        this.loading = false
      }
    },
    
    // 筛选
    handleFilter() {
      this.pagination.page = 1
      this.loadLogs()
    },
    
    // 重置
    handleReset() {
      this.filterForm = {
        status: '',
        dateRange: []
      }
      this.pagination.page = 1
      this.loadLogs()
    },
    
    // 重置筛选条件
    resetFilter() {
      this.filterForm = {
        status: '',
        dateRange: []
      }
      this.pagination = {
        page: 1,
        pageSize: 20,
        total: 0
      }
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadLogs()
    },
    
    // 页码改变
    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadLogs()
    },
    
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.userId = null
      this.username = ''
      this.logs = []
      this.resetFilter()
    },
    
    // 格式化时间
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    }
  }
}
</script>

<style scoped>
.filter-section {
  margin-bottom: 15px;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.dialog-footer {
  text-align: right;
}
</style>

